// extracted by mini-css-extract-plugin
export var sectionHeader = "SectionHeader-module--sectionHeader--1XFvK";
export var badge = "SectionHeader-module--badge--1KQfK";
export var bigText = "SectionHeader-module--bigText--1RNs_";